module.exports = "/build/web/images/icons/knvb-icon.b7b4a31979efe518f6f55c7d783235fe.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/knvb-icon.png
// module id = 125
// module chunks = 24